// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2qN6c","header":"MessagesList_header__2cSav","chat":"MessagesList_chat__31VfF"};